/* Print My Pet – Brevo newsletter
   Mode "form":  posts to the Brevo form action URL (from Brevo → Forms → Share → "HTML" action URL),
                 Double-Opt-In is configured in Brevo. No API key in the browser.
   Mode "proxy": posts JSON to your own endpoint (backend/pod-router /proxy/newsletter) which calls
                 the Brevo API with DOI template – keeps the key server-side.
   Mode "shopify": falls back to Shopify's native customer form (Brevo Shopify app syncs).

   Loaded exactly once from layout/theme.liquid. The guards below still matter because
   Shopify's Section Rendering API can re-run this file after a section refresh. */
(() => {
  'use strict';
  if (window.__pmpNewsletterReady) return;
  window.__pmpNewsletterReady = true;

  const T = (window.PMP && window.PMP.strings) || {};

  const bind = (form) => {
    if (form.dataset.nlBound === 'true') return;
    form.dataset.nlBound = 'true';

    const mode = form.dataset.brevo;
    const msg = form.querySelector('[data-nl-msg]');
    const btn = form.querySelector('button[type=submit]');
    const show = (text, isError) => {
      if (!msg) return;
      msg.textContent = text || '';
      msg.className = isError ? 'form-error' : 'form-success';
      msg.hidden = false;
    };

    form.addEventListener('submit', async (e) => {
      if (mode === 'shopify') return; // native submit
      e.preventDefault();
      if (form.querySelector('[name=honeypot]')?.value) return;

      const emailField = form.querySelector('input[type=email]');
      // The form carries `novalidate` so the browser never checks anything –
      // without this an empty field was posted and answered with "success".
      if (!emailField || !emailField.value.trim() || !emailField.checkValidity()) {
        show(form.dataset.msgEmail || T.newsletterEmailInvalid || 'Bitte gib eine gültige E-Mail-Adresse ein.', true);
        emailField?.focus();
        return;
      }

      const consent = form.querySelector('[name=consent]');
      if (consent && !consent.checked) { show(form.dataset.msgConsent, true); consent.focus(); return; }

      if (btn) btn.disabled = true;
      try {
        if (mode === 'form') {
          await fetch(form.action, { method: 'POST', body: new FormData(form), mode: 'no-cors' }); // opaque response
        } else {
          const r = await fetch(form.action, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: emailField.value.trim(),
              firstname: form.firstname?.value || '',
              pet: form.pet?.value || '',
              source: location.pathname,
              locale: document.documentElement.lang
            })
          });
          if (!r.ok) throw new Error('proxy ' + r.status);
        }
        show(form.dataset.msgSuccess);
        form.reset();
      } catch (err) {
        show(form.dataset.msgError, true);
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  };

  const bindAll = () => document.querySelectorAll('form[data-brevo]').forEach(bind);
  bindAll();
  // Forms that arrive with a re-rendered section (cart drawer, fly-in) get bound too.
  document.addEventListener('shopify:section:load', bindAll);
  document.addEventListener('pmp:newsletter:refresh', bindAll);
})();

/* F061 31.10.2026 (Kopie PMP DAUERLAUF 3110): Farbe hat jetzt Vorrang vor der Größe (Farbe bleibt, wenn es sie im Kleidungsstück gibt,
   sonst sichtbarer Ersatz mit Hinweis). Dieses Skript ist allein zuständig für Farbe und Größe bei Kleidung (window.__pmpKombi),
   pmp-auswahl-1210.js hält sich dort heraus. Vorher klickten beide Skripte mit verschiedenen Regeln gegeneinander (Olivgrün gegen
   Schwarz 5XL), bis teeinblue eine ungültige Kombination erwischte und Preis und Auswahl verschwanden. Neu außerdem: Farb- oder
   Größenwechsel innerhalb eines Kleidungsstücks auf eine nicht vorhandene Kombination wird abgefangen, Klickreihenfolge über gültige Zwischenstände.
   P1 30.10.2026: Wechsel des Kleidungsstücks (T-Shirt, Hoodie, Sweatshirt).
   Ursache: teeinblue behält beim Wechsel die zuletzt gewählte Farbe und Größe. Gibt es diese Kombination im neuen Kleidungsstück nicht
   (z. B. Hoodie Olivgrün 5XL nach Sweatshirt), bleibt die Auswahl leer, der Preis fällt auf den Grundpreis und der Kaufpfad ist blockiert.
   Fix: Beim Wechsel wird eine Kombination gewählt, die es in beiden Kleidungsstücken gibt (Größe hat Vorrang, weil sie passen muss, danach
   die nächste Farbe). Fehlt nach dem Wechsel trotzdem die Auswahl, lädt die Seite mit einer gültigen Variante neu. Alle Werte stammen aus
   den Variantendaten der Seite, die Beschriftungen sind in jeder Sprache dieselben wie dort. */
(function(){
  var L=(document.documentElement.lang||'de').slice(0,2).toLowerCase();
  var SZ=['XXS','XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL'];
  var HN={
    de:'Diese Kombination gibt es bei {g} nicht. Wir haben {c}, {s} für dich gewählt. Bitte prüfe deine Auswahl.',
    en:'That combination is not available for {g}. We selected {c}, {s} for you. Please check your choice.',
    fr:'Cette combinaison n’existe pas pour {g}. Nous avons choisi {c}, {s} pour toi. Vérifie ton choix.',
    es:'Esta combinación no existe para {g}. Hemos elegido {c}, {s} para ti. Comprueba tu selección.',
    it:'Questa combinazione non esiste per {g}. Abbiamo scelto {c}, {s} per te. Controlla la tua scelta.',
    nl:'Deze combinatie bestaat niet voor {g}. We hebben {c}, {s} voor je gekozen. Controleer je keuze.',
    pl:'Takiej kombinacji nie ma dla: {g}. Wybraliśmy dla Ciebie {c}, {s}. Sprawdź swój wybór.',
    pt:'Esta combinação não existe para {g}. Escolhemos {c}, {s} para ti. Confirma a tua escolha.',
    sv:'Den kombinationen finns inte för {g}. Vi har valt {c}, {s} åt dig. Kontrollera ditt val.',
    da:'Den kombination findes ikke til {g}. Vi har valgt {c}, {s} til dig. Tjek dit valg.',
    fi:'Tätä yhdistelmää ei ole tuotteelle {g}. Valitsimme sinulle {c}, {s}. Tarkista valintasi.',
    cs:'Tato kombinace pro {g} neexistuje. Vybrali jsme pro tebe {c}, {s}. Zkontroluj svůj výběr.',
    sk:'Táto kombinácia pre {g} neexistuje. Vybrali sme pre teba {c}, {s}. Skontroluj svoj výber.',
    hu:'Ez a kombináció a(z) {g} esetében nem létezik. Neked {c}, {s} lett kiválasztva. Ellenőrizd a választást.',
    ro:'Această combinație nu există pentru {g}. Am ales pentru tine {c}, {s}. Verifică alegerea.',
    bg:'Тази комбинация не съществува за {g}. Избрахме {c}, {s} за теб. Провери избора си.',
    el:'Αυτός ο συνδυασμός δεν υπάρχει για {g}. Επιλέξαμε {c}, {s} για σένα. Έλεγξε την επιλογή σου.',
    hr:'Ta kombinacija ne postoji za {g}. Odabrali smo {c}, {s} za tebe. Provjeri svoj odabir.',
    sl:'Te kombinacije za {g} ni. Izbrali smo {c}, {s} zate. Preveri svojo izbiro.',
    lt:'Šio derinio {g} nėra. Pasirinkome {c}, {s} tau. Patikrink savo pasirinkimą.'
  };
  function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}
  var VJ=null;
  function variants(){ if(VJ===null){ var el=document.querySelector('[data-variants-json]'); try{ VJ=JSON.parse(el.textContent) }catch(e){ VJ=[] } } return VJ }
  function lblOf(i){ var d=i&&i.closest&&i.closest('.tee-radio'); var l=d&&d.querySelector('label'); return l?(l.getAttribute('data-pmp-name')||l.getAttribute('title')||l.textContent.trim()):null }
  function garRadios(){ return $$('input[type=radio]').filter(function(i){ return !i.name&&/^teeinblue-available-prod-/.test(i.id) }) }
  function groupOf(kind,gid){ return $$('input[type=radio][name="'+kind+'-'+gid+'"]') }
  function pick(kind,gid,label){ return groupOf(kind,gid).filter(function(i){ return lblOf(i)===label })[0] }
  function checked(kind,gid){ return groupOf(kind,gid).filter(function(i){ return i.checked })[0] }
  function szi(s){ var k=SZ.indexOf(s); return k<0?99:k }
  /* Gewünschte Auswahl: zuletzt von der Person angeklickte Farbe und Größe (Beschriftungen) */
  var want={c:null,s:null}, busy=false, runT=null, userT=false, lastG=null;
  /* Laufender Stand der Auswahl: teeinblue baut beim Klick auf das Kleidungsstück schon um, bevor das change-Ereignis ankommt */
  function snap(){
    var a=garRadios().filter(function(i){ var d=i.closest('.tee-radio'); return d&&/active/.test(d.className) })[0]; if(a) lastG=a.value;
    if(userT) return;
    var c=null,s=null;
    $$('input[type=radio]:checked').forEach(function(i){ if(!i.offsetParent) return; if(/^color-\d+$/.test(i.name)) c=lblOf(i); else if(/^size-\d+$/.test(i.name)) s=lblOf(i) });
    if(c&&s){ want.c=c; want.s=s }
  }
  setInterval(snap,250);
  function gLabel(g){ var i=garRadios().filter(function(x){ return x.value===String(g) })[0]; return lblOf(i)||'' }
  function validFor(garment){ return variants().filter(function(v){ return v.available&&v.options&&v.options[0]===garment }) }
  /* Beste Kombination in 'garment': genau die Wunschkombination, sonst Farbe behalten mit nächster Größe (vorrang 'c', Standard),
     bei vorrang 's' (Person hat die Größe angeklickt) Größe behalten mit anderer Farbe */
  function nahe(cs,s){ cs.sort(function(a,b){ var d=Math.abs(szi(a.options[2])-szi(s))-Math.abs(szi(b.options[2])-szi(s)); return d||(szi(b.options[2])-szi(a.options[2])) }); return cs[0] }
  function best(garment,c,s,alsoIn,vorrang){
    var vs=validFor(garment); if(!vs.length) return null;
    if(alsoIn){ var ok=validFor(alsoIn).map(function(v){ return v.options[1]+'|'+v.options[2] }); vs=vs.filter(function(v){ return ok.indexOf(v.options[1]+'|'+v.options[2])>-1 }); if(!vs.length) return null }
    var ex=vs.filter(function(v){ return v.options[1]===c&&v.options[2]===s })[0]; if(ex) return {c:c,s:s,exact:true};
    var sameCol=vs.filter(function(v){ return v.options[1]===c });
    if(sameCol.length&&vorrang!=='s'){ var n=nahe(sameCol,s); return {c:c,s:n.options[2]} }
    var sameSize=vs.filter(function(v){ return v.options[2]===s });
    if(sameSize.length){ var sc=sameSize.filter(function(v){ return v.options[1]===c })[0]||sameSize[0]; return {c:sc.options[1],s:s} }
    var cs=sameCol.length?sameCol:vs.filter(function(v){ return v.options[1]===vs[0].options[1] });
    var m=nahe(cs,s);
    return {c:m.options[1],s:m.options[2]};
  }
  function hint(garment,c,s){
    var f=null; garRadios().forEach(function(i){ if(!f) f=i.closest('.tee-field') }); if(!f) return;
    var p=f.querySelector('.pmp-kombi-hinweis'); if(!p){ p=document.createElement('p'); p.className='pmp-kombi-hinweis'; p.setAttribute('role','status'); p.style.cssText='margin:.6rem 0 0;font-size:.9rem;line-height:1.4'; f.appendChild(p) }
    p.textContent=(HN[L]||HN.en).replace('{g}',garment).replace('{c}',c).replace('{s}',s);
  }
  function clearHint(){ $$('.pmp-kombi-hinweis').forEach(function(p){ p.textContent='' }) }
  function click(i){ if(i&&!i.checked){ busy=true; try{ i.click() }finally{ busy=false } } }
  /* Verborgene Shopify-Auswahl und Formular-ID auf die gewählte Variante stellen (ohne Ereignis) */
  function syncForm(garment){
    var gid=null; garRadios().forEach(function(i){ if(i.checked||(i.closest('.tee-radio')||{}).className&&/active/.test(i.closest('.tee-radio').className)) gid=i.value });
    var c=checked('color',gid), s=checked('size',gid); if(!c||!s) return;
    var cl=lblOf(c), sl=lblOf(s);
    var v=variants().filter(function(x){ return x.options&&x.options[0]===garment&&x.options[1]===cl&&x.options[2]===sl })[0]; if(!v) return;
    var id=document.querySelector('form[data-product-form] input[name="id"]'); if(id&&String(id.value)!==String(v.id)) id.value=v.id;
    v.options.forEach(function(o,k){ $$('input[name="option-'+(k+1)+'"]').forEach(function(r){ var t=(r.getAttribute('data-label')||r.value)===o; if(r.checked!==t&&t) r.checked=true }) });
  }
  var gSel=null;
  function finish(t0,garment,desired,showHint){
    var gid=gSel; var tries=0;
    clearInterval(runT);
    runT=setInterval(function(){
      tries++;
      var cg=groupOf('color',gid), sg=groupOf('size',gid);
      if(!cg.length||!sg.length){
        if(Date.now()-t0>3500){ clearInterval(runT); revive(garment,desired) }
        return;
      }
      var cc=checked('color',gid), ss=checked('size',gid);
      var cl=lblOf(cc), sl=lblOf(ss);
      if(!desired||(cl===desired.c&&sl===desired.s)){ if(cl&&sl){ clearInterval(runT); want.c=cl; want.s=sl; syncForm(garment); if(showHint) hint(garment,desired.c,desired.s) } if(Date.now()-t0>3500){ clearInterval(runT); if(!cl||!sl) revive(garment,desired) } return }
      /* Reihenfolge so, dass der Zwischenstand eine verfügbare Kombination ist */
      var gibt=function(c,s){ return validFor(garment).some(function(v){ return v.options[1]===c&&v.options[2]===s }) };
      if(cl!==desired.c&&sl!==desired.s&&!gibt(desired.c,sl)&&gibt(cl,desired.s)){ click(pick('size',gid,desired.s)) }
      else if(cl!==desired.c){ click(pick('color',gid,desired.c)) }
      else if(sl!==desired.s){ click(pick('size',gid,desired.s)) }
      if(tries>40){ clearInterval(runT); syncForm(garment) }
    },150);
  }
  /* Notfall: nach dem Wechsel fehlt jede Auswahl (teeinblue hat sich verschluckt). Seite mit gültiger Variante neu laden. */
  function revive(garment,desired){
    if(document.querySelector('.tee-variants input:checked')) return;
    var d=desired||best(garment,want.c,want.s)||null, vs=validFor(garment);
    var v=(d&&vs.filter(function(x){ return x.options[1]===d.c&&x.options[2]===d.s })[0])||vs[0]; if(!v) return;
    try{ if(sessionStorage.getItem('pmp-kombi-revive')===String(v.id)) return; sessionStorage.setItem('pmp-kombi-revive',String(v.id)) }catch(e){}
    location.replace(location.pathname+'?variant='+v.id);
  }
  /* Für pmp-auswahl-1210.js: Farbe und Größe bei Kleidung mit Kleidungsstückauswahl entscheidet nur dieses Skript */
  window.__pmpKombi={zustaendig:function(g){
    if(!g||!g.classList||!(g.classList.contains('tee-option--color')||g.classList.contains('tee-option--size'))) return false;
    if(!$$('input[type=radio][name^="color-"]').length||!$$('input[type=radio][name^="size-"]').length) return false;
    return garRadios().some(function(i){ return validFor(lblOf(i)||'').length>0 });
  }};
  /* Klick auf das schon gewählte Kleidungsstück: kein change-Ereignis, teeinblue baut trotzdem neu auf und springt auf Schwarz.
     Die vorher gewählte Farbe und Größe werden wieder gesetzt. */
  document.addEventListener('click',function(e){
    if(!e.isTrusted||busy) return;
    var rd=e.target&&e.target.closest&&e.target.closest('.tee-radio'); if(!rd) return;
    var i=rd.querySelector('input[type=radio]'); if(!i||i.name||!/^teeinblue-available-prod-/.test(i.id)) return;
    if(!(i.checked||/active/.test(rd.className))||!want.c||!want.s) return;
    var g=lblOf(i)||rd.textContent.trim(), d=best(g,want.c,want.s,null); if(!d) return;
    var t0=Date.now(); gSel=i.value; setTimeout(function(){ finish(t0,g,d,!d.exact) },60);
  },true);
  document.addEventListener('change',function(e){
    var r=e.target; if(!r||r.type!=='radio'||busy) return;
    if(r.name&&/^(color|size)-/.test(r.name)&&e.isTrusted){
      userT=true; var l=lblOf(r), istC=/^color-/.test(r.name); if(istC) want.c=l; else want.s=l; clearHint();
      /* Wechsel innerhalb des Kleidungsstücks auf eine Kombination, die es nicht gibt: Angeklicktes behalten, das andere nächstliegend ersetzen */
      var gid=(r.name.match(/-(\d+)$/)||[])[1], gl=gid?gLabel(gid):'';
      if(gl&&validFor(gl).length){
        var oc=istC?checked('size',gid):checked('color',gid), ol=lblOf(oc)||(istC?want.s:want.c);
        var wc2=istC?l:ol, ws2=istC?ol:l;
        if(wc2&&ws2&&!validFor(gl).some(function(v){ return v.options[1]===wc2&&v.options[2]===ws2 })){
          var d3=best(gl,wc2,ws2,null,istC?'c':'s'); if(d3){ gSel=gid; finish(Date.now(),gl,d3,true) }
        }
      }
      return;
    }
    if(!r.name&&/^teeinblue-available-prod-/.test(r.id)&&e.isTrusted){
      var garment=lblOf(r)||(r.closest('.tee-radio')&&r.closest('.tee-radio').textContent.trim()); gSel=r.value;
      /* Vorher gewähltes Kleidungsstück: Stand aus dem laufenden Abbild, die alten Gruppen sind meist schon ersetzt */
      var oldG=(lastG&&String(lastG)!==String(r.value))?lastG:null, oldC=oldG?checked('color',oldG):null, oldS=oldG?checked('size',oldG):null;
      var wc=want.c, ws=want.s, og=oldG?gLabel(oldG):null;
      if(!wc||!ws){ finish(Date.now(),garment,null,false); return }
      var d=best(garment,wc,ws,og||null);
      /* Vor teeinblue die alten Gruppen auf eine in beiden Kleidungsstücken gültige Kombination stellen, damit teeinblue nichts Ungültiges mitnimmt */
      if(d&&oldG&&og&&(lblOf(oldC)!==d.c||lblOf(oldS)!==d.s)){ click(pick('color',oldG,d.c)); click(pick('size',oldG,d.s)) }
      var d2=best(garment,wc,ws,null);
      finish(Date.now(),garment,d2,!!d2&&!d2.exact);
    }
  },true);
})();
